export default __webpack_public_path__ + "static/media/res-project-1.bb779379.jpg";